const _ = require('lodash');

const {
    getCurrencyCode,
    prettifyCardNumber,
    prettifyDateTimeV2
} = require('./string');

const {
    fraudMapper,
    transactionStatusMapper,
    transactionTypeMapper,
    processMethodMapper,
    cardTypesMapper,
    cycleTypes,
    merchantProcessorType,
    mapType,
    retryEngineTypesMapper,
    paymentRecoveryStatusTypesMapper,
    payoutStatusMapper,
    transferStatusMapper,
    payoutProviderMapper,
    spendbackStatusMapper
} = require('./mappers');

const {
    gatewayAndApmMapper
} = require('./gateways/gatewayMapper');
const moment = require('moment');

function date(data) {
    return data.value ? prettifyDateTimeV2(data.value, { returnDateOnly: true }) : '';
}

function dateGetTimezone(data) {
    const dateToResolve = _.get(data, 'value') || _.get(data, 'original.transactionDate') || false;
    return dateToResolve
        ? prettifyDateTimeV2(dateToResolve, {
            timezoneOutput: data.timezone,
            dateTimeFormatOutput: 'z'
        })
        : '';
}

function getDisputeByDate(reportDate = '', chargebackCycle = 0, processorType = 20, timezone) {
    if (reportDate && (chargebackCycle === 1 || chargebackCycle === 3)) {

        const processorDaysToDispute = {
            [merchantProcessorType.fdr]: 14,
            [merchantProcessorType.tsys]: 10
        };

        const daysToDispute = processorDaysToDispute[processorType];

        if (!_.isEqual(daysToDispute, 'Unknown')) {
            const disputeByDate = moment(reportDate).add(daysToDispute, 'days');

            return prettifyDateTimeV2(disputeByDate, { returnDateOnly: true, timezoneOutput: timezone });
        }

        return 'Unknown';
    }

    return '';
}

function getDisputeByDateByProcessorType(data) {
    const { timezone } = data;
    const { reportDate, chargebackCycle, processor } = data.original;
    const processorType = _.get(processor, 'processorType');

    return getDisputeByDate(reportDate, chargebackCycle, processorType, timezone);
}

const dataTransform = {
    date,
    dateGetTimezone,
    dateLong: (data) => (data.value ? prettifyDateTimeV2(data.value, 'YYYY-MM-DD h:mm:ss A') : ''),
    dateTimezone: (data) => (data.value ? prettifyDateTimeV2(data.value, { timezoneOutput: data.timezone }) : ''),
    dateTimezoneButHideTimezone: (data) => (data.value ? prettifyDateTimeV2(data.value, { timezoneOutput: data.timezone, dateTimeFormatOutput: 'MM/DD/YYYY hh:mm A' }) : ''),
    processMethodMapper: (data) => _.get(processMethodMapper, data.value, '').toUpperCase(),
    cardTypesMapper: (data) => _.get(cardTypesMapper, data.value, '').toUpperCase(),
    transactionTypeMapper: (data) => _.get(transactionTypeMapper, data.value, '').toUpperCase(),
    transactionStatusMapper: (data) => _.get(transactionStatusMapper, data.value, '').toUpperCase(),
    retryEngineTypeMapper: (data) => _.get(retryEngineTypesMapper, data.value, '').toUpperCase(),
    recoveryStatusMapper: (data) => _.get(paymentRecoveryStatusTypesMapper, data.value, '').toUpperCase(),
    gatewayMapper: (data) => _.get(gatewayAndApmMapper, data.value, '').toUpperCase(),
    fraudMapper: (data) => _.get(fraudMapper, data.value, ''),
    uppercase: (data) => (data.value ? data.value.toUpperCase() : ''),
    ellipsisNumber: (data) => (data.value ? prettifyCardNumber(data.value) : ''),
    currencyCode: (data) => getCurrencyCode(data.value, { defaultCurrencyId: '840' }).toUpperCase(),
    currencyCodeNoDefault: (data) => getCurrencyCode(data.value, {}).toUpperCase(),
    uppercaseCell: (data) => (data.value ? data.value.toUpperCase() : ''),
    trimStart: (data) => _.trimStart(data.value, '0'),
    isDisputed: (data) => (data.value ? 'Disputed' : null),
    isEnabled: (data) => (data.value ? 'Enabled' : 'Disabled'),
    mapType: (data) => mapType(data.value, cycleTypes),
    disputeByDateByProcessorType: (data) => getDisputeByDateByProcessorType(data) || '',
    payoutStatusMapper: (data) => _.toUpper(_.startCase(_.get(payoutStatusMapper, data.value, ''))),
    transferStatusMapper: (data) => _.get(transferStatusMapper, data.value, '').toUpperCase(),
    payoutProviderMapper: (data) => _.get(payoutProviderMapper, data.value, '').toUpperCase(),
    spendbackStatusMapper: (data) => _.toUpper(_.startCase(_.get(spendbackStatusMapper, data.value, '')))
};

module.exports = {
    date,
    dateGetTimezone,
    getDisputeByDate,
    getDisputeByDateByProcessorType,
    dataTransform
};
